import React from "react";
import { connect } from "react-redux";
import {
  Paper,
  Typography,
  Grid,
  Button,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
} from "@mui/material";
import endpoint from "../../../config/endpoints";
import { apiGet } from "../../../utils/api_service";
import { withRouter } from "../../../components/withRouter";
import { noInternetMsg } from "../../../config/messageconstant";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import LandingScreenHeader from "../../../components/Comman/LandingScreenHeader";

const LabelWithShowMore = ({ label, value }) => {
  const [showAll, setShowAll] = React.useState(false);
  const valuesArray = typeof value === "string" ? value.split(",") : [];
  const displayedValues = showAll ? valuesArray : valuesArray.slice(0, 7);
  const shouldShowMore = valuesArray.length > 7;

  return (
    <Grid
      item
      xs={12}
      sm={valuesArray?.length > 7 ? 12 : 6}
      md={valuesArray?.length > 7 ? 12 : 6}
      lg={valuesArray?.length > 7 ? 12 : 6}
    >
      <Box display="flex" alignItems="flex-start">
        <Typography
          variant="body1"
          component="span"
          sx={{
            color: "#39c1d4",
            fontWeight: 500,
            minWidth: "298px",
            flexShrink: 0,
          }}
        >
          {label} :
        </Typography>

        <Box
          sx={{
            display: "inline",
            flex: 1,
            wordBreak: "break-word",
            whiteSpace: "normal",
          }}
        >
          <Typography
            variant="body1"
            component="span"
            sx={{
              wordBreak: "break-word",
              whiteSpace: "normal",
            }}
          >
            {displayedValues.join(", ")}{" "}
          </Typography>

          {shouldShowMore && (
            <Button
              onClick={() => setShowAll(!showAll)}
              size="small"
              sx={{
                textTransform: "none",
                padding: "0px 4px",
                minWidth: "auto",
                fontSize: "12px",
                color: "#39c1d4",
              }}
            >
              {showAll ? "Show Less" : "Show More"}
            </Button>
          )}
        </Box>
      </Box>
    </Grid>
  );
};

const StyledInlineLabelValue = ({ label, value }) => (
  <>
    <Grid item xs={6} sm={3} md={3} lg={3}>
      <Typography variant="body1" sx={{ color: "#39c1d4", fontWeight: 500 }}>
        {label} :
      </Typography>
    </Grid>
    <Grid item xs={6} sm={3} md={3} lg={3}>
      <Typography variant="body1">{value}</Typography>
    </Grid>
  </>
);

class StockHolderView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      headerData: {},
    };
  }

  async componentDidMount() {
    const { showLoador, showNotification, params } = this.props;
    if (navigator.onLine) {
      if (params.id) {
        showLoador({ loador: true });
        await apiGet({
          url:
            endpoint.stackholder +
            "/get-by-id?stockStakeHolderId=" +
            this.props.params.id,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (success) {
            this.setState({ headerData: data.data });
          }
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  onCancel = () => {
    this.props.navigate(-1);
  };

  render() {
    const { headerData } = this.state;

    return (
      <Paper sx={{ p: 2, borderRadius: 0 }} elevation={0}>
        <LandingScreenHeader
          screenTitle={"Stock Holder View"}
          showTable={false}
          showBackButton={true}
          showAddButton={false}
          onCancel={this.onCancel}
        />

        <br></br>

        <Grid container spacing={2}>
          <LabelWithShowMore
            label="Type"
            value={headerData?.stockStakeHolderTypeName || "-"}
          />

          <LabelWithShowMore label="Pincode" value={headerData?.pincode} />
          <LabelWithShowMore
            label="Order To"
            value={headerData?.orderToName || "-"}
          />
          <LabelWithShowMore
            label="Owner Name"
            value={headerData?.ownerName || "-"}
          />
          <LabelWithShowMore
            label="Firm Name"
            value={headerData?.firmName || "-"}
          />
          <LabelWithShowMore
            label="SPOC"
            value={headerData?.contactPersonName || "-"}
          />
          <LabelWithShowMore
            label="Contact Number"
            value={headerData?.contactPersonNo || "-"}
          />
          <LabelWithShowMore
            label="Firm Address"
            value={headerData?.address || "-"}
          />
          <LabelWithShowMore
            label="Email Id"
            value={headerData?.emailId || "-"}
          />

          <LabelWithShowMore
            label="GST Type"
            value={
              headerData?.gstType === 1
                ? "Non Register"
                : headerData?.gstType === 2
                ? "Composite"
                : headerData?.gstType === 3
                ? "Regular"
                : "-"
            }
          />

          <LabelWithShowMore
            label="PAN Number"
            value={headerData?.panNo || "-"}
          />
          <LabelWithShowMore
            label="FSSAI Number"
            value={headerData?.fssiFdiNo || "-"}
          />
          <LabelWithShowMore
            label="Bill Name"
            value={headerData?.billName || "-"}
          />
          <LabelWithShowMore
            label="Credit Limit"
            value={headerData?.creditLimit || "-"}
          />
          <LabelWithShowMore
            label="Payment Term"
            value={headerData?.paymentName || "-"}
          />
          <LabelWithShowMore label="UPI" value={headerData?.upi || "-"} />
          <LabelWithShowMore
            label="FSSAI Expiry Date"
            value={headerData?.expiryDate || "-"}
          />
          <LabelWithShowMore
            label="Brand"
            value={headerData?.brandName || "-"}
          />
          <LabelWithShowMore label="From Date" value={headerData?.fromDate} />
          <LabelWithShowMore
            label="To Date"
            value={headerData?.toDate || "-"}
          />

          <LabelWithShowMore
            label="GST Type"
            value={
              headerData?.gstType === 1
                ? "Yes"
                : headerData?.gstType === 0
                ? "No"
                : "-"
            }
          />

          <LabelWithShowMore
            label="  Sequence-Wise Outlet Order"
            value={
              headerData?.sequenceWiseOrder === 1
                ? "Yes"
                : headerData?.sequenceWiseOrder === 0
                ? "No"
                : "-"
            }
          />

          <LabelWithShowMore
            label=" Outlet Edit"
            value={
              headerData?.outletEdit === 1
                ? "Yes"
                : headerData?.outletEdit === 0
                ? "No"
                : "-"
            }
          />

          <StyledInlineLabelValue
            label="Bill Number Sequence"
            value={headerData.billNoSequence ?? "-"}
          />

          <LabelWithShowMore
            label="  Is DMS Applicable"
            value={
              headerData?.isDmsApplicable === 1
                ? "Yes"
                : headerData?.isDmsApplicable === 0
                ? "No"
                : "-"
            }
          />

          <LabelWithShowMore
            label="Region"
            value={headerData.regionName || "-"}
          />

          <LabelWithShowMore
            label="State"
            value={headerData.stateNames || "-"}
          />

          <LabelWithShowMore label="Zone" value={headerData.zoneNames || "-"} />

          <LabelWithShowMore
            label="District"
            value={headerData.districtNames || "-"}
          />

          <LabelWithShowMore
            label="Taluka"
            value={headerData.talukaNames || "-"}
          />

          <LabelWithShowMore label="Area" value={headerData.areaNames || "-"} />
        </Grid>
      </Paper>
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  showNotification,
  showLoador,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(StockHolderView));
